import React, { ChangeEvent, useEffect, useId, useRef } from 'react';

interface CheckboxProps {
  id?: string;
  label?: string;
  checked?: boolean;
  indeterminate?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  id,
  label = '',
  checked = false,
  indeterminate = false,
  onChange,
  disabled = false,
  className = '',
}) => {
  const generatedId = useId();
  const checkboxId = id || generatedId;
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    if (onChange) {
      onChange(isChecked);
    }
  };

  return (
    <div className={`checkbox-container ${className}`}>
      <input
        ref={inputRef}
        className="checkbox-container__input"
        type="checkbox"
        id={checkboxId}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
      />
      {label && (
        <label className="checkbox-container__label" htmlFor={checkboxId}>
          {label}
        </label>
      )}
    </div>
  );
};
